import { TableOutlined } from "@ant-design/icons";
import { tableCore } from "./core/table";
import { defineWidget } from "../widgetDefinition";
import { tableSlots } from "../Slots";
import { tableDuplicate } from "../Duplication/table";
import { tableControlPanel } from "../ControlPanel/table";
import { TableInfo } from "../Info/table";
import type { TableComponentSpec } from "../Processing/types";
import { TableWidget } from "../WidgetComponents/TableWidget";
import { TableConfigurator } from "../AddWidgetModal/TableConfigurator";
import { BINDABLE_SECTIONS } from "../Processing/controllerBindings";

export const tableDefinition = defineWidget<TableComponentSpec>({
  ...tableCore,
  type: "table",
  dynamic: { bindableSections: BINDABLE_SECTIONS.table },
  slots: tableSlots,
  duplicate: tableDuplicate,
  controlPanel: tableControlPanel,
  info: { Content: TableInfo },
  schema: ["display", "series", "mutations", "table_builder_misc"],
  contractHash: "0udani9bfav",
  needsData: true,

  template: {
    label: "Table",
    description: "Tabular breakdown of metrics by player or drill",
    icon: <TableOutlined />,
  },

  defaultLayout: { w: 6, h: 12, minW: 3, minH: 2 },

  gridComponent: ({ id }) => <TableWidget id={id} />,

  configurator: {
    modalTitle: "Table Widget",
    wide: true,
    Component: TableConfigurator as any,
  },
});
